<template>
  <section id="portfolio-container" class="pt-48 bg-white -mt-48 min-h-screen">
    <div class="bg-[#F7F8FA] py-20">
      <div class="container-1">
        <div class="figtree font-semibold text-ip-color-3 text-2xl leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] uppercase bg-ip-color-10 rounded-md w-fit p-[.38rem]">Our Client</div>
        <!-- <div class="figtree w-full font-semibold text-ip-color-3 text-2xl leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] ">Proud to Have Served</div> -->
      </div>
      <div class="container-1 relative">
        <div ref="lineCont" id="line-container" class="absolute w-full h-full top-0 left-0 flex justify-center z-0">
          <div class="h-full w-[2px] bg-gray-300">
            <div class="progress"></div>
          </div>
          <div class="bottom-grad"></div>
          <div class="top-grad"></div>
          <div class="absolute w-full left-0" v-for="(item,i) in items" :key="i" :class="`point-container-${i}`">
            <div class="point">
              <div class="point-inner"></div>
            </div>
          </div>
        </div>
        <div v-for="(item,i) in items" :key="i" class="grid grid-cols-2 gap-24 items-center" :class="`item-${i}`">
          <div class="py-24 relative" :class="[
            {'order-0': i % 2 === 0, 'order-1': i % 2 !== 0},
            ]">
            <figure class="aspect-[285/227] bg-gray-300 rounded-xl overflow-hidden relative">
              <img :src="config.public.cdnUrl+config.public.cdnFolder+item.img_src" alt="" class="w-full h-full object-cover">
              <div class="overlay"></div>
            </figure>
          </div>
          <div class="space-y-6" :class="{'order-1': i % 2 === 0, 'order-0': i % 2 !== 0}">
            <div class="text-[24px] leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree text-primary">{{ item.title[lang] }}</div>
            <div class="text-[16px] leading-[32px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-semibold figtree">{{ item.subtitle[lang] }}</div>
            <div class="text-[14px] leading-[24px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.7vw] figtree" v-html="item.description[lang]"></div>
          </div>
        </div>
      </div>
      <div v-if="!noMore" id="load-more-desktop" class="flex justify-center mt-6">
        <button class="">
          <span class="loading loading-spinner loading-xs text-primary"></span>
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useResizeObserver } from '@vueuse/core';
 
 
const lang = ref('id')
const config = useRuntimeConfig();
const props = defineProps({
  items: { type: Array, default: null },
  noMore: { type: Boolean, default: false },
});
const emits = defineEmits(['loadMore']);
const lineCont = ref(null);
const observers = [];
const moreObserver = ref(null);
const loadMore = ref(false);
const containerObserver = ref(null);
useResizeObserver(lineCont, (entries) => {
  // const entry = entries[0]
  // const { width, height } = entry.contentRect
  // text.value = `width: ${width}, height: ${height}`
  setPoint();
});

onMounted(() => {
  setPoint();
  startObserver();
});
const pointPositions = ref([]);
const setPoint = () => {
  const lineContainer = document.querySelector('#line-container').getBoundingClientRect();
  const containerHeight = lineContainer.height;
  const gap = containerHeight / (props.items.length);
  props.items.forEach((item, i) => {
    const el = document.querySelector(`.point-container-${i}`);
    el.style.top = ((gap * i) + (gap / 2)) + 'px';
    pointPositions.value[i] = ((gap * i) + (gap / 2));
  });
};

const progress = ref(0);
const calculateScrollPercentage = () => {
  const element = document.querySelector('#portfolio-container');
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const elementTop = rect.top;
  const elementHeight = rect.height;
  progress.value = Math.abs((elementTop / (elementHeight - windowHeight)) * 100);
  if (elementTop < 0) {
    if (progress.value <= 0) {
      progress.value = 0;
    } else if (progress.value >= 100) {
      progress.value = 100;
    }
    const progElementHeight = document.querySelector('.progress').getBoundingClientRect().height;
    pointPositions.value.forEach((pos, i) => {
      if (progElementHeight >= pos) {
        document.querySelector(`.point-container-${i} .point`).classList.add('active');
      } else {
        document.querySelector(`.point-container-${i} .point`).classList.remove('active');
      }
    });
    document.querySelector('.progress').style.height = progress.value + '%';
  }
};

const startObserver = () => {
  disconnectObservers();
  const entries = [];
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0],
  };
  props.items.forEach((item, index) => {
    const el = document.querySelector(`.item-${index}`);
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          calculateScrollPercentage();
        }
      });
    };
    observers[index] = new IntersectionObserver(callback, options);
    if (el) observers[index].observe(el);
  });
  const container = document.querySelector('#portfolio-container');
  const containerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        calculateScrollPercentage();
      }
    });
  };
  containerObserver.value = new IntersectionObserver(containerCallback, options);
  containerObserver.value.observe(container);

  const moreCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadMore.value = true;
      }
    });
  };

  const moreEl = document.querySelector('#load-more-desktop');
  if (moreEl) {
    moreObserver.value = new IntersectionObserver(moreCallback, options);
    moreObserver.value.observe(moreEl);
  }
};

const disconnectObservers = () => {
  observers.forEach(observer => observer.disconnect());
  if (moreObserver.value) moreObserver.value.disconnect();
  if (containerObserver.value) containerObserver.value.disconnect();
};

watch(() => loadMore.value, (val) => {
  if (val) {
    emits('loadMore');
  }
});

watch(() => props.items.length, (val) => {
  if (val) {
    startObserver();
    nextTick(() => {
      loadMore.value = false;
    });
  }
});

</script>

<style lang="scss" scoped>
  .overlay {
    @apply w-full h-full absolute;
    left: 0px;
    bottom: 0.16px;
    background: linear-gradient(180deg, rgba(38, 38, 104, 0.25) 0%, rgba(38, 38, 104, 0.26) 59.22%, #262668 100%);
  }

  .bottom-grad {
    position: absolute;
    width: 338px;
    height: 127px;
    bottom: -60px;
    background: #F7F8FA;
    filter: blur(28.35px);
  }

  .top-grad {
    position: absolute;
    width: 338px;
    height: 127px;
    top: -60px;
    background: #F7F8FA;
    filter: blur(28.35px);
  }

  .point {
    @apply w-[14px] h-[14px] rounded-full border-2 border-gray-300 flex bg-white mx-auto items-center justify-center;
    .point-inner {
      @apply w-[5.6px] h-[5.6px] rounded-full bg-gray-300 flex;
    }
    &.active {
      @apply border-primary;
      animation: bounce 450ms;
      animation-timing-function: linear;
      .point-inner {
        @apply bg-primary;
      }
    }
  }

  .progress {
    @apply bg-primary w-full flex rounded-full;
  }

  @keyframes bounce {
    25% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.4);
    }
    75% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1.1);
    }
  }
</style>
